import { render, staticRenderFns } from "./Bmi.vue?vue&type=template&id=54212bee&scoped=true&"
import script from "./Bmi.vue?vue&type=script&lang=js&"
export * from "./Bmi.vue?vue&type=script&lang=js&"
import style0 from "./Bmi.vue?vue&type=style&index=0&id=54212bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54212bee",
  null
  
)

export default component.exports